import { Component, OnInit, OnDestroy } from '@angular/core';
import { MultiDeviceInteractionState } from '../../../models/consumer/consumer-interaction.model';
import { DatePickerOptions, DatePickerModel } from '../date-picker/date-picker.component';

@Component({
    selector: 'multi-device-when',
    templateUrl: './multi-device-when.component.html',
    styles: []
})
export class MultiDeviceWhenComponent implements OnInit, OnDestroy{

    constructor() {
        this.currentDate = new Date();
        this.dateOptions.minDate = this.currentDate;
        this.dateOptions.maxDate = new Date(this.currentDate.getFullYear() + 2, 1);
    }

    subscriptions: any[] = [];
    multiDeviceState: MultiDeviceInteractionState;
    currentDate: Date;
    selectedDate: Date;
    dateOptions: DatePickerOptions = {};

    ngOnInit() { }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    datePickerChange(dates: DatePickerModel) {
        if (!dates || !dates.dateFrom ) return;
        this.selectedDate = dates.dateFrom;
    }
}
